// extracted by mini-css-extract-plugin
export default {"candidatesTable":"CandidatesTableNew_candidatesTable__44ipH"};